var rtl_rtlignore_default = {
  "rtl": "f2Kn1",
  "ltr": "C02O6"
};
export {
  rtl_rtlignore_default as default
};
//# sourceMappingURL=rtl.rtlignore-scss.js.map
